import { jsx as _jsx } from "react/jsx-runtime";
import { StyledVisuallyHidden } from './VisuallyHidden.styled.js';
export const VisuallyHidden = ({ focusable = false, ...rest }) => {
    return _jsx(StyledVisuallyHidden, { "$focusable": focusable, ...rest });
};
//# sourceMappingURL=VisuallyHidden.js.map